<script setup>

import {useUserStore} from "@/stores/user.store";
import {storeToRefs} from "pinia/dist/pinia";
import {onMounted, ref} from "vue";

const userStore = useUserStore();
const timezoneId = ref(1);

onMounted(async () => {
    await userStore.fetchUser();
    await userStore.fetchUserTimezones();
    timezoneId.value = userStore.user.timezone.id;
})

const {timezones} = storeToRefs(userStore);

const updateUser = async () => {
    await userStore.updateUserTimezone(timezoneId.value);
}

</script>

<template>
    <van-form @submit="updateUser">
        <van-radio-group v-model="timezoneId">
            <van-cell-group inset>
                <van-cell v-for="timezone in timezones" :key="timezone.id" :title="timezone.name" clickable
                          @click="timezoneId = timezone.id">
                    <template #right-icon>
                        <van-radio :name="timezone.id" :checked="timezoneId === timezone.id"/>
                    </template>
                </van-cell>
            </van-cell-group>
        </van-radio-group>
        <van-divider/>
        <van-cell-group inset>
            <van-button block round type="success" native-type="submit">
                Update
            </van-button>
        </van-cell-group>
    </van-form>
</template>
